import { DELETE_FILE, GET_CAMPAIGNS, GET_CAMPAIGN, POST_FILE, POST_CAMPAIGNS, SET_FIELD } from './actions';

const initialState = {
  campaigns: [],

  campaign: {
    title: '',
    description: '',
    published: false,
    files: [],
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DELETE_FILE.SUCCESS:
      return {
        ...state,
        campaign: {
          ...state.campaign,
          files: state.campaign.files.filter(file => file.id !== action.data.file.id),
        }
      };
    case GET_CAMPAIGNS.SUCCESS:
      return {
        ...state,
        campaigns: action.payload.campaigns
      };
    case GET_CAMPAIGN.REQUEST: {
      const campaign = state.campaigns.find(cmp => cmp.id === action.data.id);

      if (campaign) {
        return {
          ...state,
          campaign: {
            ...campaign,
            files: [],
          },
        };
      }
      return state;
    }
    case GET_CAMPAIGN.SUCCESS:
      return {
        ...state,
        campaign: action.payload.campaign
      };
    case POST_CAMPAIGNS.SUCCESS:
      return {
        ...state,
        campaign: {
          ...state.campaign,
          id: action.payload.campaign.id,
        }
      };
    case POST_FILE.REQUEST:
      return {
        ...state,
        campaign: {
          ...state.campaign,
          files: [
            ...state.campaign.files,
            {
              id: action.data.id, // temporal ID
              type: action.data.type,
              name: action.data.file.name,
              size: action.data.file.size,
            }
          ],
        },
      };
    case POST_FILE.SUCCESS: {
      const tempId = action.data.id;
      const saved = action.payload[action.data.type];
      return {
        ...state,
        campaign: {
          ...state.campaign,
          files: state.campaign.files.map(file => {
            if (file.id === tempId) {
              return {
                ...saved,
                type: action.data.type,
              };
            }

            return file;
          })
        },
      };
    }
    case POST_FILE.FAIL: {
      const tempId = action.data.id;
      return {
        ...state,
        campaign: {
          ...state.campaign,
          files: state.campaign.files.filter(file => file.id !== tempId)
        },
      };
    }
    case SET_FIELD:
      return {
        ...state,
        campaign: {
          ...state.campaign,
          [action.payload.name]: action.payload.value,
        }
      };
    default:
      return state;
  }
}